export default __webpack_public_path__ + "assets/cr_pt_highlight.52e65ae7.svg";